import { createSelector } from "reselect";

import { RootState } from "../../rootReducer";

export const selectCount = createSelector(
  [(store: RootState) => store.formSubmittedSlice.counter],
  (data) => data
);
